import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { EnumButtonSizes, EnumRouteNames }	from '@/enums/enums';
import { useRouter }						from 'vue-router';
import { useInstitutionalStore } 			from '@/stores/institutionalStore';
import { useAuthStore }						from '@/stores/authStore';
import { usePagesUtilStore }                from '@/stores/pagesUtilStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnViewFocusedInstitutional',
  props: {
  propBtnSize: {
    type: String as () => keyof typeof EnumButtonSizes,
    required: false,
    default: EnumButtonSizes.LARGE_1
  },
  id: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const router = useRouter();
const authStore		= useAuthStore();
const pagesUtilStore  = usePagesUtilStore();
const institutionalStore = useInstitutionalStore();


const props = __props;


const onViewInstitutional = () => {
  router.push({
    name: EnumRouteNames.INSTITUTIONAL_VIEW,
    params: { id: props.id }
  });
};


return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (_unref(authStore).currentUserCanViewInstitutional)
    ? (_openBlock(), _createBlock(_component_c_q_btn, {
        key: 0,
        id: "btn-view-institutional",
        propBtnLabel: "Visualizar",
        propBtnFunction: onViewInstitutional,
        propBtnTransparent: true,
        propBtnSize: props.propBtnSize
      }, null, 8, ["propBtnSize"]))
    : _createCommentVNode("", true)
}
}

})